module.exports = __webpack_public_path__ + "img/fas-graduation-cap.0313d472.svg";